// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1Gg58","buttons":"PendingPaymentAlert_buttons__34M6t"};